import { Component, OnInit } from '@angular/core';
import { PropiedadesRuralesService } from '../_services';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from '@angular/forms';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-propiedades-rurales',
  templateUrl: './propiedades-rurales.component.html',
  styleUrls: ['./propiedades-rurales.component.css']
})
export class PropiedadesRuralesComponent implements OnInit {
  public propiedades: Array<object> = [];
  public propiedadesAux: Array<object> = [];
  filtrarForm: FormGroup;
  departamentoList = [];
  departamentosMarcadosList = [];
  dropdownSettings = {};

  constructor(
    private propiedadesRuralesService: PropiedadesRuralesService
  ) { }

  ngOnInit() {
    this.filtrarForm = new FormGroup({
      campo: new FormControl(),
      valor: new FormControl()
    });
    this.getPropiedades();
    this.getDepartamentos();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'descripcion',
      selectAllText: 'Todos',
      unSelectAllText: 'Desmarcar todos',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: 'Buscar'
    };
  }

  public getPropiedades() {
    this.propiedadesRuralesService.getPropiedadesRurales().subscribe(
      (data: Array<Object>) => {
        this.propiedades = data;
        this.propiedades.map((s: any) => {
          s.imagenes.map((i) => {
            i.url = environment.baseUrl + '/..' + i.url;
          });
        });
        this.propiedadesAux = this.propiedades;
      });
  }

  public separadorMiles(input) {
    const ret = input ? input.replace(/,/gi, '.') : null;
    return ret;
  }
  public getDepartamentos() {
    this.propiedadesRuralesService.getDepartamentos().subscribe((data: Array<object>) => {
      this.departamentoList = data;
    });
  }

  onDepartamentoSelect(item: any) {
    this.departamentosMarcadosList.push(item.id);
    this.filtrarDepartamento();
  }

  onDepartamentoDeSelect(item: any) {
    this.departamentosMarcadosList.splice(
      this.departamentosMarcadosList.indexOf(item.id),
      1
    );
    this.filtrarDepartamento();
  }

  onDepartamentoSelectAll(items) {
    this.departamentosMarcadosList = [];
    items.forEach(item => {
      this.departamentosMarcadosList.push(item.id);
    });
    this.filtrarDepartamento();
  }

  filtrarDepartamento() {
    if (this.departamentosMarcadosList.length === 0) {
      this.propiedades = this.propiedadesAux;
    } else {
      this.propiedades = [];
    }
    this.departamentosMarcadosList.forEach((dep) => {
      this.propiedadesAux.filter(propiedad => propiedad['departamento']['id'] === dep).forEach((prop) => {
        this.propiedades.push(prop);
      });
    });

  }

}
